<script>
import draggable from "vuedraggable";
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import appConfig from "@/app.config";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import { uuid } from "vue-uuid";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  mixins: [Api, Sabit],
  page: {
    title: "Anket Oluştur",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Loader, Layout, PageHeader, draggable,Treeselect },
  data() {
    return {
      title: this.$t("CreateAnket.Title"),
      items: [
        {
          text: this.$t("CreateAnket.Title"),
          active: true,
        },
      ],

      FormData: [],
      FormJson: [],
      AnktAnketId: this.$route.params.AnktAnketId,
      BolumIcon: ["fas fa-address-card", "fas fa-adjust", "fas fa-align-center", "fas fa-align-justify", "fas fa-align-left", "fas fa-align-right"],
      enabled: true,
      list: [
        { name: "John", id: 0 },
        { name: "Joao", id: 1 },
        { name: "Jean", id: 2 },
      ],
      dragging: false,
      BagliSoruCombo:[],
      dragOptions: {
        scroll: true,
        scrollSensitivity: 120,
        scrollSpeed: 15,
        forceFallback: true,
        fallbackOnBody: true,
      }
    };
  },
  methods: {
    BagliSoruOptions(id){   
      return this.BagliSoruCombo.filter((e)=>e.id !== id )
    },
    CevapSorgu(Field,question){ 
      var Sorgu = this.BagliSoruCombo.filter(notification =>notification.id.includes(question)) 
      Field.options =Sorgu[0].options
      Field.bolumindex = Sorgu[0].bolumindex
      Field.soruindex = Sorgu[0].soruindex
    },
    BagliSoruSecimiCombo(){
        this.BagliSoruCombo=[]
      for(let Bolumler in this.FormJson){
        for(let Form in this.FormJson[Bolumler].FormFiled){ 
         if(this.FormJson[Bolumler].FormFiled[Form].type == "radiobutton" || this.FormJson[Bolumler].FormFiled[Form].type == "combobox"){ 
               
              var options=[]
              for(var cevaplar in this.FormJson[Bolumler].FormFiled[Form].options){
                options.push({
                  id: this.FormJson[Bolumler].FormFiled[Form].options[cevaplar].Id,
                  label:this.FormJson[Bolumler].FormFiled[Form].options[cevaplar].value
                });
              }
              this.BagliSoruCombo.push({
                id:this.FormJson[Bolumler].FormFiled[Form].Id,
                label:this.FormJson[Bolumler].FormFiled[Form].props.title,
                options:options,
                bolumindex:Bolumler,
                soruindex:Form
              });
          
          }
        }
      } 
       
    },
    SyncConnectedSoruIndexes() {
      var soruMap = {};

      for (let Bolumler in this.FormJson) {
        for (let Form in this.FormJson[Bolumler].FormFiled) {
          var Field = this.FormJson[Bolumler].FormFiled[Form];
          soruMap[Field.Id] = {
            bolumindex: Bolumler,
            soruindex: Form,
            options: Field.options,
          };
        }
      }

      for (let Bolumler in this.FormJson) {
        for (let Form in this.FormJson[Bolumler].FormFiled) {
          var Connected = this.FormJson[Bolumler].FormFiled[Form].connected;

          if (Connected && Connected.question && soruMap[Connected.question]) {
            this.$set(Connected, "bolumindex", soruMap[Connected.question].bolumindex);
            this.$set(Connected, "soruindex", soruMap[Connected.question].soruindex);
            this.$set(Connected, "options", soruMap[Connected.question].options);
          }
        }
      }
    },
    BolumDragEnd() {
      this.dragging = false;
      this.BagliSoruSecimiCombo();
      this.SyncConnectedSoruIndexes();
    },
    BolumAdd() {
      this.FormJson.push({
        FormTitle: "Başlıksız Form " + (this.FormJson.length + 1),
        FormIcon: "",
        FormFiled: [],
      });
    },
    BolumDel(Bolumindex) {
      this.FormJson.splice(Bolumindex, 1);
    },
    SoruAdd(Bolumindex) {
      this.FormJson[Bolumindex].FormFiled.push({
        Id: uuid.v4(),
        SiraNo: this.FormJson[Bolumindex].FormFiled.length + 1,
        type: "input",
        props: {
          title: "Soru " + (this.FormJson[Bolumindex].FormFiled.length + 1),
          helpText: "",
        },
        config: {
          min: "",
          max: "",
          required: false,
          maxSelections: 10,
          placeHolder: null,
          type: "",
          rows: null,
          columns: null,
        },
        options: [],
        connected:{
          question:null,
          reply:null,
          options:null,
          bolumindex:null,
          soruindex:null,
        }
      }); 
    },
    SoruDel(Bolumindex, index) {
      this.$delete(this.FormJson[Bolumindex].FormFiled, index);
    },
    
    SoruCopy(Bolumindex, index) {  
      var CopyFielJson = JSON.stringify(this.FormJson[Bolumindex].FormFiled[index])
      CopyFielJson = JSON.parse(CopyFielJson);
      CopyFielJson.Id=uuid.v4()
      this.FormJson[Bolumindex].FormFiled.push(CopyFielJson);
    },
    OptinonsAdd(Bolumindex, index) {
      this.FormJson[Bolumindex].FormFiled[index].options.push({
        Id: uuid.v4(),
        value: "Seçenek",
        selected: false,
      });
    },
    OptinonsDel(Bolumindex, index, optionsindex) {
      this.$delete(this.FormJson[Bolumindex].FormFiled[index].options, optionsindex);
    },
    SatirSutunAdd(Bolumindex, index, Satir) {
      if (Satir == "Satir") {
        this.FormJson[Bolumindex].FormFiled[index].options.Satir.push({
          Id: uuid.v4(),
          value: "Seçenek",
        });
      } else {
        this.FormJson[Bolumindex].FormFiled[index].options.Sutun.push({
          Id: uuid.v4(),
          value: "Seçenek",
          selected: false,
        });
      }
    },
    SatirSutunDel(Bolumindex, index, optionsindex, Satir) {
      if (Satir == "Satir") {
        this.$delete(this.FormJson[Bolumindex].FormFiled[index].options.Satir, optionsindex);
      } else {
        this.$delete(this.FormJson[Bolumindex].FormFiled[index].options.Sutun, optionsindex);
      }
    },
    submit() {
      this.SyncConnectedSoruIndexes();
      this.FormData.Anketjson = JSON.stringify(this.FormJson);
      this.Update("AnktAnket", this.FormData).then((res) => {
        if (res) {
          this.$bvModal.hide("CreateAnket");
        }
      });
    },
    Get() {
      var TumAnketlerKontrol = false;
      let YetkiSorgu = this.UserRolles.filter(
        (item) =>
          item.includes("AnketTumAnketler") || item.includes("SuperAdmin")
      );
      if (YetkiSorgu.length != 0) TumAnketlerKontrol = true;

      var BirimAnketlerKontrol = false;
      YetkiSorgu = this.UserRolles.filter((item) =>
        item.includes("AnketBirimAnketler")
      );
      if (YetkiSorgu.length != 0) BirimAnketlerKontrol = true;

      if (!TumAnketlerKontrol) {
        var Filter = "&Yetkilipersonelid=" + this.TokenUserId;
        Filter += "&Id=" + this.AnktAnketId;

        if (BirimAnketlerKontrol) {
          Filter += "&Birimanketlerinigorme=true";
        }

        this.ActionsFilterGet({
          Service: "AnktAnket",
          Page: this.PageToplu,
          Filter: Filter,
        }).then((res) => {
          if (res.Data.length == 0) {
            window.location = "/";
          }
        });
      }
      
    },
    TipSecim(Bolumindex, index, Tip) {
      this.FormJson[Bolumindex].FormFiled[index].type = Tip;
 
      if (Tip == "rangeslider") {
        this.FormJson[Bolumindex].FormFiled[index].options.push({
          mintitle: "Minimum",
          min: 1,
          maxtitle: "Maximum",
          max: 10,
        });
      } else if (Tip == "CoktanSecmeliTablo") {
        this.FormJson[Bolumindex].FormFiled[index].options = {
          Satir: [],
          Sutun: [],
        };
      } else if (Tip == "OnayKutuluTablo") {
        this.FormJson[Bolumindex].FormFiled[index].options = {
          Satir: [],
          Sutun: [],
        };
      } 
    },
  },
  created() {
    this.ActionsSingleGet({
      Service: "AnktAnket",
      Id: this.AnktAnketId,
    }).then((res) => {
      this.FormData = res.Data;
      this.FormJson = JSON.parse(this.FormData.Anketjson);
      this.BagliSoruSecimiCombo()
    });
  },
};
</script>
<style>
.dropdown-menu.show {
  overflow-y: scroll !important;
  height: 200px !important;
}

.bolum-drag-handle {
  cursor: move;
}
</style>
<template>
  <Loader>
    <Layout>
      <PageHeader
        :title="FormData.Baslik"
        :items="[
          {
            text: $t('CreateAnket.Page.Anasayfa'),
            href: '/',
          },
          {
            text: $t('CreateAnket.Page.UstMenu'),
            active: true,
          },
          {
            text: FormData.Baslik,
            active: true,
          },
        ]"
      />

      <div class="row">  
        <div class="col-12">
          <draggable :list="FormJson" :disabled="!enabled" v-bind="dragOptions" class="list-group" ghost-class="ghost" handle=".bolum-drag-handle" @start="dragging = true" @end="BolumDragEnd">
          <div v-for="(Bolumler, Bolumindex) in FormJson" :key="Bolumindex" class="bolum-list-item">
            <div class="row">
              <div class="col-12">
                <b-card bg-variant="primary" class="text-white-50">
                  <div class="row">
                    <div class="col-4">
                      <h5 class="mt-0 mb-1 text-white">
                        <i class="bx bx-move bolum-drag-handle font-size-24 align-middle mx-2"></i>
                        <i class="mdi mdi-bullseye-arrow me-1"></i>
                        {{ Bolumler.FormTitle }}
                      </h5>
                    </div>
                    <div class="col-8">
                      <h5 class="mt-0 mb-1 text-white">
                        <div class="text-sm-end">
                          {{ $t("CreateAnket.AddEdit.Bolum") }}
                          {{ Bolumindex + 1 }} / {{ FormJson.length }}
                        </div>
                      </h5>
                    </div>
                  </div>
                  <br />

                  <div class="row">
                    <div class="col-8">
                      <h5 class="mt-0 mb-1 text-white">
                        <b-form-group :label="$t('CreateAnket.AddEdit.FomBasligi')" label-cols-sm="3" label-cols-lg="3">
                          <b-form-input v-model="Bolumler.FormTitle" type="text"></b-form-input>
                        </b-form-group>
                      </h5>
                    </div>

                    <div class="col-4">
                      <div class="row">
                        <div class="col-8">
                          <b-dropdown variant="success">
                            <template v-slot:button-content>
                              <i :class="Bolumler.FormIcon"></i>
                              {{ $t("CreateAnket.AddEdit.BolumIconEkle") }}
                              <i class="mdi mdi-chevron-down"></i>
                            </template>
                            <b-dropdown-item v-for="(IconBolum, BolumIconIndex) in BolumIcon" :key="BolumIconIndex" @click="Bolumler.FormIcon = IconBolum"><i :class="IconBolum"></i></b-dropdown-item>
                          </b-dropdown>
                        </div>

                        <div class="col-4">
                          <h5 class="mt-0 mb-1 text-white">
                            <div class="text-sm-end">
                              <i
                                @click="BolumDel(Bolumindex)"
                                class="
                                  bx bx-trash
                                  font-size-24
                                  align-middle
                                  mx-2
                                "
                              ></i>
                            </div>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group col-md-1"></div>
                </b-card>
              </div>
            </div>

            <draggable :list="Bolumler.FormFiled" :disabled="!enabled" v-bind="dragOptions" class="list-group" ghost-class="ghost" @start="dragging = true" @end="dragging = false">
              <div class="row" v-for="(Form, index) in Bolumler.FormFiled" :key="index">
                <div class="col-12"> 
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group col-md-6" v-if="Form.type == 'input'">
                          <b-form-group :label="$t('CreateAnket.AddEdit.SoruBasligi')">
                            <b-form-input v-model="Form.props.title" type="text"></b-form-input>
                          </b-form-group>
                          <br />
                          <b-form-group :label="$t('CreateAnket.AddEdit.PlaceHolder')" label-cols-sm="3" label-cols-lg="3">
                             <b-form-input v-model="Form.config.placeHolder" type="text"></b-form-input> </b-form-group><br />
                          <b-form-group :label="$t('CreateAnket.AddEdit.KontrolTipi')" label-cols-sm="3" label-cols-lg="3">
                            <select class="form-control" v-model="Form.config.type">
                              <option value="text">Metin</option>
                              <option value="number">Sayı</option>
                            </select>
                          </b-form-group>
                          <br />
                          <div class="row" v-if="Form.config.type == 'number'">
                            <div class="col-md-6">
                              <b-form-group :label="$t('CreateAnket.AddEdit.min')" label-cols-sm="3" label-cols-lg="3">
                                <b-form-input v-model="Form.config.min" type="text"></b-form-input>
                              </b-form-group>
                            </div>

                            <div class="col-md-6">
                              <b-form-group :label="$t('CreateAnket.AddEdit.max')" label-cols-sm="3" label-cols-lg="3">
                                <b-form-input v-model="Form.config.max" type="text"></b-form-input>
                              </b-form-group>
                            </div>
                          </div>
                        </div>

                        <div class="form-group col-md-6" v-if="Form.type == 'textarea'">
                          <b-form-group :label="$t('CreateAnket.AddEdit.SoruBasligi')">
                            <b-form-input v-model="Form.props.title" type="text"></b-form-input>
                          </b-form-group>
                          <br />

                          <b-form-group :label="$t('CreateAnket.AddEdit.PlaceHolder')" label-cols-sm="3" label-cols-lg="3">
                            <b-form-input v-model="Form.config.placeHolder" type="text"></b-form-input>
                          </b-form-group>
                        </div>

                        <div class="form-group col-md-6" v-if="Form.type == 'radiobutton'">
                          <b-form-group :label="$t('CreateAnket.AddEdit.SoruBasligi')">
                            <b-form-input v-model="Form.props.title" type="text"></b-form-input>
                          </b-form-group>
                          <br />

                          <div class="row">
                            <div class="row mb-3" v-for="(options, optionsindex) in Form.options" :key="optionsindex">
                              <div class="form-group d-flex align-items-center">
                                <i class="bx bx-radio-circle-marked font-size-24"></i>
                                <b-form-input v-model="options.value" :value="$t('CreateAnket.AddEdit.Secenek')" type="text"></b-form-input>
                                <i @click="OptinonsDel(Bolumindex, index, optionsindex)" class="bx bx-trash font-size-24 align-middle mx-2"></i>
                              </div>
                            </div>
                            <div class="row justify-content-end">
                              <div class="col-sm-7">
                                <i
                                  @click="OptinonsAdd(Bolumindex, index)"
                                  class="
                                    bx bx-plus-circle
                                    font-size-24
                                    align-middle
                                    mx-2
                                    mb-4
                                  "
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group col-md-6" v-if="Form.type == 'checkbox'">
                          <b-form-group :label="$t('CreateAnket.AddEdit.SoruBasligi')">
                            <b-form-input v-model="Form.props.title" type="text"></b-form-input>
                          </b-form-group>
                          <br />

                          <div class="row">
                            <div class="row mb-3" v-for="(options, optionsindex) in Form.options" :key="optionsindex">
                              <div class="form-group d-flex align-items-center">
                                <i class="bx bx-check-square font-size-24"></i>
                                <b-form-input v-model="options.value" :value="$t('CreateAnket.AddEdit.Secenek')" type="text"></b-form-input>
                                <i @click="OptinonsDel(Bolumindex, index, optionsindex)" class="bx bx-trash font-size-24 align-middle mx-2"></i>
                              </div>
                            </div>
                            <div class="row justify-content-end">
                              <div class="col-sm-7">
                                <i
                                  @click="OptinonsAdd(Bolumindex, index)"
                                  class="
                                    bx bx-plus-circle
                                    font-size-24
                                    align-middle
                                    mx-2
                                    mb-4
                                  "
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group col-md-6" v-if="Form.type == 'combobox'">
                          <b-form-group :label="$t('CreateAnket.AddEdit.SoruBasligi')">
                            <b-form-input v-model="Form.props.title" type="text"></b-form-input>
                          </b-form-group>
                          <br />
                          <div class="row">
                            <div class="row mb-3" v-for="(options, optionsindex) in Form.options" :key="optionsindex">
                              <div class="form-group d-flex align-items-center">
                                <i class="bx bx bx-list-ol font-size-24"></i>
                                <b-form-input v-model="options.value" type="text"></b-form-input>
                                <i @click="OptinonsDel(Bolumindex, index, optionsindex)" class="bx bx-trash font-size-24 align-middle mx-2"></i>
                              </div>
                            </div>

                            <div class="row justify-content-end">
                              <div class="col-sm-7">
                                <i
                                  @click="OptinonsAdd(Bolumindex, index)"
                                  class="
                                    bx bx-plus-circle
                                    font-size-24
                                    align-middle
                                    mx-2
                                    mb-4
                                  "
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group col-md-6" v-if="Form.type == 'date'">
                          <b-form-group :label="$t('CreateAnket.AddEdit.SoruBasligi')" >
                            <b-form-input v-model="Form.props.title" type="text"></b-form-input>
                          </b-form-group>
                          <br />

                          <b-form-group :label="$t('CreateAnket.AddEdit.PlaceHolder')" label-cols-sm="3" label-cols-lg="3">
                            <b-form-input v-model="Form.config.placeHolder" type="text"></b-form-input>
                          </b-form-group>
                        </div>

                        <div class="form-group col-md-6" v-if="Form.type == 'time'">
                          <b-form-group :label="$t('CreateAnket.AddEdit.SoruBasligi')">
                            <b-form-input v-model="Form.props.title" type="text"></b-form-input>
                          </b-form-group>
                          <br />

                          <b-form-group :label="$t('CreateAnket.AddEdit.PlaceHolder')" label-cols-sm="3" label-cols-lg="3">
                            <b-form-input v-model="Form.config.placeHolder" type="text"></b-form-input>
                          </b-form-group>
                        </div>

                        <div class="form-group col-md-6" v-if="Form.type == 'file'">
                          <b-form-group :label="$t('CreateAnket.AddEdit.SoruBasligi')" >
                            <b-form-input v-model="Form.props.title" type="text"></b-form-input>
                          </b-form-group>
                          <br />
                        </div>

                        <div class="form-group col-md-6" v-if="Form.type == 'rangeslider'">
                          <b-form-group :label="$t('CreateAnket.AddEdit.SoruBasligi')">
                            <b-form-input v-model="Form.props.title" type="text"></b-form-input>
                          </b-form-group>
                          <br />

                          <div class="row">
                            <div class="form-group col-md-6">
                              <select class="form-control" v-model="Form.options[0].min">
                                <option value="0">0</option>
                                <option value="1">1</option>
                              </select>
                            </div>

                            <div class="form-group col-md-6">
                              <select class="form-control" v-model="Form.options[0].max">
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                              </select>
                            </div>
                          </div>
                          <br />
                          <b-form-group label="İlk Etiket: " label-cols-sm="3" label-cols-lg="3"> <b-form-input v-model="Form.options[0].mintitle" type="text"></b-form-input> </b-form-group><br />
                          <b-form-group label="Son Etiket: " label-cols-sm="3" label-cols-lg="3">
                            <b-form-input v-model="Form.options[0].maxtitle" type="text"></b-form-input>
                          </b-form-group>
                        </div>

                        <div class="form-group col-md-6" v-if="Form.type == 'CoktanSecmeliTablo'">
                        
                        
                          <b-form-group :label="$t('CreateAnket.AddEdit.SoruBasligi')">
                            <b-form-input v-model="Form.props.title" type="text"></b-form-input>
                          </b-form-group>

                          <br />

                          <div class="row">
                            <h5>Satırlar</h5>

                            <div class="mb-3" v-for="(options, optionsindex) in Form.options.Satir" :key="optionsindex">
                              <div class="form-group d-flex align-items-center">
                                <b-form-input v-model="options.value" :value="$t('CreateAnket.AddEdit.Secenek')" type="text"></b-form-input>
                                <i @click="SatirSutunDel(Bolumindex, index, optionsindex, 'Satir')" class="bx bx-trash font-size-24 align-middle mx-2"></i>
                              </div>
                            </div>

                            <div class="d-flex justify-content-center">
                              <i
                                @click="SatirSutunAdd(Bolumindex, index, 'Satir')"
                                class="
                                  bx bx-plus-circle
                                  font-size-24
                                  align-middle
                                  mx-2
                                  mb-4
                                "
                              ></i>
                            </div>

                            <h5>Sütunlar</h5>
                            <div class="mb-3" v-for="(options, optionsindex) in Form.options.Sutun" :key="optionsindex">
                              <div class="form-group align-items-center d-flex">
                                <i class="bx bx-radio-circle-marked font-size-24"></i>
                                <b-form-input v-model="options.value" :value="$t('CreateAnket.AddEdit.Secenek')" type="text"></b-form-input>
                                <i @click="SatirSutunDel(Bolumindex, index, optionsindex, 'Sutun')" class="bx bx-trash font-size-24 align-middle mx-2"></i>
                              </div>
                            </div>
                            <div class="d-flex justify-content-center">
                              <i
                                @click="SatirSutunAdd(Bolumindex, index, 'Sutun')"
                                class="
                                  bx bx-plus-circle
                                  font-size-24
                                  align-middle
                                  mx-2
                                  mb-4
                                "
                              ></i>
                            </div>
                          </div>
                        </div>

                        <div class="form-group col-md-6" v-if="Form.type == 'OnayKutuluTablo'">
                          <b-form-group :label="$t('CreateAnket.AddEdit.SoruBasligi')">
                            <b-form-input v-model="Form.props.title" type="text"></b-form-input>
                          </b-form-group>
                          <br />

                          <div class="row">
                            <h5>Satırlar</h5>

                            <div class="my-3" v-for="(options, optionsindex) in Form.options.Satir" :key="optionsindex">
                              <div
                                class="
                                  d-flex
                                  justify-content-between
                                  align-items-center
                                "
                              >
                                <b-form-input v-model="options.value" :value="$t('CreateAnket.AddEdit.Secenek')" type="text"></b-form-input>
                                <i @click="SatirSutunDel(Bolumindex, index, optionsindex, 'Satir')" class="bx bx-trash font-size-24 align-middle mx-2"></i>
                              </div>
                            </div>

                            <div class="row justify-content-end">
                              <div class="col-sm-7">
                                <i
                                  @click="SatirSutunAdd(Bolumindex, index, 'Satir')"
                                  class="
                                    bx bx-plus-circle
                                    font-size-24
                                    align-middle
                                    mx-2
                                    mb-4
                                  "
                                ></i>
                              </div>
                            </div>

                            <h5>Sütunlar</h5>

                            <div class="my-3" v-for="(options, optionsindex) in Form.options.Sutun" :key="optionsindex">
                              <div
                                class="
                                  d-flex
                                  justify-content-between
                                  align-items-center
                                  my-1
                                "
                              >
                                <i class="bx bx-check-square font-size-24 "></i>
                                <b-form-input v-model="options.value" :value="$t('CreateAnket.AddEdit.Secenek')" type="text"></b-form-input>
                                <i @click="SatirSutunDel(Bolumindex, index, optionsindex, 'Sutun')" class="bx bx-trash font-size-24 align-middle mx-2"></i>
                              </div>
                            </div>
                            <div class="row justify-content-end">
                              <div class="col-sm-7">
                                <i
                                  @click="SatirSutunAdd(Bolumindex, index, 'Sutun')"
                                  class="
                                    bx bx-plus-circle
                                    font-size-24
                                    align-middle
                                    mx-2
                                    mb-4
                                  "
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group col-md-3">
                          
                            
                              <b-form-group label="Soru Tipi: ">
                                <b-dropdown variant="secondary" class="select-from">
                                  <template v-slot:button-content>
                                    <div class="d-flex align-items-left">
                                      <div class="d-flex align-items-center" v-if="Form.type == 'input'">
                                        <i
                                          class="
                                            bx
                                            bxs-rename
                                            font-size-22
                                            align-middle
                                          "
                                        ></i>
                                        <div class="mx-3">
                                          {{ $t("CreateAnket.AddEdit.input") }}
                                        </div>
                                      </div>

                                      <div class="d-flex align-items-center" v-if="Form.type == 'textarea'">
                                        <i
                                          class="
                                            bx bx-font-family
                                            font-size-22
                                            align-middle
                                          "
                                        ></i>
                                        <div class="mx-3">
                                          {{ $t("CreateAnket.AddEdit.textarea") }}
                                        </div>
                                      </div>

                                      <div class="d-flex align-items-center" v-if="Form.type == 'radiobutton'">
                                        <i
                                          class="
                                            bx bx-radio-circle-marked
                                            font-size-22
                                            align-middle
                                          "
                                        ></i>
                                        <div class="mx-3">
                                          {{ $t("CreateAnket.AddEdit.radiobutton") }}
                                        </div>
                                      </div>

                                      <div class="d-flex align-items-center" v-if="Form.type == 'checkbox'">
                                        <i
                                          class="
                                            bx bx-check-square
                                            font-size-22
                                            align-middle
                                          "
                                        ></i>
                                        <div class="mx-3">
                                          {{ $t("CreateAnket.AddEdit.checkbox") }}
                                        </div>
                                      </div>

                                      <div class="d-flex align-items-center" v-if="Form.type == 'file'">
                                        <i
                                          class="
                                            bx
                                            bxs-image
                                            font-size-22
                                            align-middle
                                          "
                                        ></i>
                                        <div class="mx-3">
                                          {{ $t("CreateAnket.AddEdit.file") }}
                                        </div>
                                      </div>

                                      <div class="d-flex align-items-center" v-if="Form.type == 'combobox'">
                                        <i
                                          class="
                                            bx
                                            bxs-down-arrow
                                            font-size-22
                                            align-middle
                                          "
                                        ></i>
                                        <div class="mx-3">
                                          {{ $t("CreateAnket.AddEdit.combobox") }}
                                        </div>
                                      </div>

                                      <div class="d-flex align-items-center" v-if="Form.type == 'rangeslider'">
                                        <i
                                          class="
                                            bx bx bx-list-ol
                                            font-size-22
                                            align-middle
                                          "
                                        ></i>
                                        <div class="mx-3">
                                          {{ $t("CreateAnket.AddEdit.rangeslider") }}
                                        </div>
                                      </div>

                                      <div class="d-flex align-items-center" v-if="Form.type == 'CoktanSecmeliTablo'">
                                        <i
                                          class="
                                            bx bx-radio-circle-marked
                                            font-size-22
                                            align-middle
                                          "
                                        ></i>
                                        <div class="mx-3">
                                          {{ $t("CreateAnket.AddEdit.CoktanSecmeliTablo") }}
                                        </div>
                                      </div>

                                      <div class="d-flex align-items-center" v-if="Form.type == 'OnayKutuluTablo'">
                                        <i
                                          class="
                                            bx bx-check-square
                                            font-size-22
                                            align-middle
                                          "
                                        ></i>
                                        <div class="mx-3">
                                          {{ $t("CreateAnket.AddEdit.OnayKutuluTablo") }}
                                        </div>
                                      </div>

                                      <div class="d-flex align-items-center" v-if="Form.type == 'date'">
                                        <i
                                          class="
                                            bx
                                            bxs-calendar-event
                                            font-size-22
                                            align-middle
                                          "
                                        ></i>
                                        <div class="mx-3">
                                          {{ $t("CreateAnket.AddEdit.date") }}
                                        </div>
                                      </div>

                                      <div class="d-flex align-items-center" v-if="Form.type == 'time'">
                                        <i
                                          class="
                                            bx
                                            bxs-time
                                            font-size-22
                                            align-middle
                                          "
                                        ></i>
                                        <div class="mx-3">
                                          {{ $t("CreateAnket.AddEdit.time") }}
                                        </div>
                                      </div>

                                      <i
                                        class="
                                          fas
                                          fa-angle-down
                                          font-size-22
                                          align-middle
                                        "
                                      ></i>
                                    </div>
                                  </template>

                                  <b-dropdown-item @click="TipSecim(Bolumindex, index, 'input')">
                                    <div class="d-flex align-items-center p-0 m-0">
                                      <i
                                        class="
                                          bx
                                          bxs-rename
                                          font-size-22
                                          align-middle
                                        "
                                      ></i>
                                      <div class="mx-3">
                                        {{ $t("CreateAnket.AddEdit.input") }}
                                      </div>
                                    </div>
                                  </b-dropdown-item>

                                  <b-dropdown-item @click="TipSecim(Bolumindex, index, 'textarea')">
                                    <div class="d-flex align-items-center m-0 p-0">
                                      <i
                                        class="
                                          bx bx-font-family
                                          font-size-22
                                          align-middle
                                        "
                                      ></i>
                                      <div class="mx-3">
                                        {{ $t("CreateAnket.AddEdit.textarea") }}
                                      </div>
                                    </div>
                                  </b-dropdown-item>

                                  <b-dropdown-item @click="TipSecim(Bolumindex, index, 'radiobutton')">
                                    <div class="d-flex align-items-center p-0 m-0">
                                      <i
                                        class="
                                          bx bx-radio-circle-marked
                                          font-size-22
                                          align-middle
                                        "
                                      ></i>
                                      <div class="mx-3">
                                        {{ $t("CreateAnket.AddEdit.radiobutton") }}
                                      </div>
                                    </div>
                                  </b-dropdown-item>

                                  <b-dropdown-item @click="TipSecim(Bolumindex, index, 'checkbox')">
                                    <div class="d-flex align-items-center m-0 p-0">
                                      <i
                                        class="
                                          bx bx-check-square
                                          font-size-22
                                          align-middle
                                        "
                                      ></i>
                                      <div class="mx-3">
                                        {{ $t("CreateAnket.AddEdit.checkbox") }}
                                      </div>
                                    </div>
                                  </b-dropdown-item>

                                  <hr />

                                  <b-dropdown-item @click="TipSecim(Bolumindex, index, 'file')">
                                    <div class="d-flex align-items-center m-0 p-0">
                                      <i
                                        class="
                                          bx
                                          bxs-image
                                          font-size-22
                                          align-middle
                                        "
                                      ></i>
                                      <div class="mx-3">
                                        {{ $t("CreateAnket.AddEdit.file") }}
                                      </div>
                                    </div>
                                  </b-dropdown-item>

                                  <hr />

                                  <b-dropdown-item @click="TipSecim(Bolumindex, index, 'combobox')">
                                    <div class="d-flex align-items-center p-0 m-0">
                                      <i
                                        class="
                                          bx
                                          bxs-down-arrow
                                          font-size-22
                                          align-middle
                                        "
                                      ></i>
                                      <div class="mx-3">
                                        {{ $t("CreateAnket.AddEdit.combobox") }}
                                      </div>
                                    </div>
                                  </b-dropdown-item>

                                  <b-dropdown-item @click="TipSecim(Bolumindex, index, 'rangeslider')">
                                    <div class="d-flex align-items-center m-0 p-0">
                                      <i
                                        class="
                                          bx bx bx-list-ol
                                          font-size-22
                                          align-middle
                                        "
                                      ></i>
                                      <div class="mx-3">
                                        {{ $t("CreateAnket.AddEdit.rangeslider") }}
                                      </div>
                                    </div>
                                  </b-dropdown-item>

                                  <b-dropdown-item @click="TipSecim(Bolumindex, index, 'CoktanSecmeliTablo')">
                                    <div class="d-flex align-items-center p-0 m-0">
                                      <i
                                        class="
                                          bx bx-radio-circle-marked
                                          font-size-22
                                          align-middle
                                        "
                                      ></i>
                                      <div class="mx-3">
                                        {{ $t("CreateAnket.AddEdit.CoktanSecmeliTablo") }}
                                      </div>
                                    </div>
                                  </b-dropdown-item>

                                  <b-dropdown-item @click="TipSecim(Bolumindex, index, 'OnayKutuluTablo')">
                                    <div class="d-flex align-items-center m-0 p-0">
                                      <i
                                        class="
                                          bx bx-check-square
                                          font-size-22
                                          align-middle
                                        "
                                      ></i>
                                      <div class="mx-3">
                                        {{ $t("CreateAnket.AddEdit.OnayKutuluTablo") }}
                                      </div>
                                    </div>
                                  </b-dropdown-item>

                                  <hr />

                                  <b-dropdown-item @click="TipSecim(Bolumindex, index, 'date')">
                                    <div class="d-flex align-items-center m-0 p-0">
                                      <i
                                        class="
                                          bx
                                          bxs-calendar-event
                                          font-size-22
                                          align-middle
                                        "
                                      ></i>
                                      <div class="mx-3">
                                        {{ $t("CreateAnket.AddEdit.date") }}
                                      </div>
                                    </div>
                                  </b-dropdown-item>

                                  <b-dropdown-item @click="TipSecim(Bolumindex, index, 'time')">
                                    <div class="d-flex align-items-center m-0 p-0">
                                      <i
                                        class="
                                          bx
                                          bxs-time
                                          font-size-22
                                          align-middle
                                        "
                                      ></i>
                                      <div class="mx-3">
                                        {{ $t("CreateAnket.AddEdit.time") }}
                                      </div>
                                    </div>
                                  </b-dropdown-item>
                                </b-dropdown>
                              </b-form-group>
                            
                          
                        </div>
                        
                                  <div class="form-group col-md-3 " v-if="Form.connected">   
                           <b-form-group 
                              id="example text"
                              label="İlişkili Soru"
                              label-for="text"
                              class="mb-2"
                            >   
                              <treeselect  
                              v-model="Form.connected.question"
                                :multiple="false" 
                                :options="BagliSoruOptions(Form.Id)"
                                :placeholder="$t('OrtakKullanim.seciniz')"  
                                @open="BagliSoruSecimiCombo()"
                                @select="CevapSorgu(Form.connected,$event.id)"
                              />
                              <treeselect-value   />

                            
                            </b-form-group> 
                          <b-form-group  v-if="Form.connected.question"
                              id="example text"
                              label="Sorunun Cevabı"
                              label-for="text"
                            > 
                              <treeselect  
                              v-model="Form.connected.reply"
                                :multiple="false" 
                                :options="Form.connected.options"
                                :placeholder="$t('OrtakKullanim.seciniz')"   
                              />
                              <treeselect-value   />

                            
                            </b-form-group>
                          
                        </div>




                        

                        <div
                          class="
                            form-group
                            col-md-12
                            d-flex
                            justify-content-end
                          "
                        >
                        <div class="form-group mx-2">
                            <i @click="SoruCopy(Bolumindex, index)" class="bx bx-copy font-size-24 align-middle mx-2"></i>
                          </div>

                          <div class="form-group mx-2">
                            <i @click="SoruDel(Bolumindex, index)" class="bx bx-trash font-size-24 align-middle mx-2"></i>
                          </div>

                          <div class="form-check form-switch form-switch-lg mb-3">
                            <input class="form-check-input" type="checkbox" v-model="Form.config.required" />
                            <label class="form-check-label" for="SwitchCheckSizelg">{{ $t("CreateAnket.AddEdit.Gerekli") }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end card -->
              </div>
            </draggable>

            <div class="d-flex justify-content-center my-5">
              <button @click="SoruAdd(Bolumindex)" type="button" class="btn btn-success"><i class="bx bx-plus-circle font-size-24 align-middle"></i>{{ $t("CreateAnket.AddEdit.SoruEkleButton") }}</button>
            </div>
          </div>
          </draggable>

          <div class="justify-content-center d-flex">
            <button @click="BolumAdd()" type="button" class="btn btn-primary"><i class="bx bx-plus-circle font-size-24 align-middle"></i>{{ $t("CreateAnket.AddEdit.BolumEkleButton") }}</button>
          </div>

          <hr />
          <div class="form-group">
            <button @click="submit" type="button" class="btn btn-primary" v-if="FormJson.length != 0">
              {{ $t("CreateAnket.AddEdit.Button") }}
            </button>
          </div>
        </div>
      </div>
    </Layout>
  </Loader>
</template>
<style>
.select-from button {
  background: white;
  border: solid 1px #5d6071;
  color: #5d6071 !important;
}
.select-from button:hover {
  background: white;
  border: solid 1px #5d6071;
  color: #5d6071 !important;
}
.select-from button:focus {
  background: white;
  border: solid 1px #5d6071;
  color: #5d6071 !important;
}
.select-from button.show {
  background: white !important;
  border: solid 1px #5d6071;
  color: #5d6071 !important;
}

.btn-check:checked + .btn-secondary,
.btn-check:active + .btn-secondary,
.btn-secondary:active,
.btn-secondary.active,
.show > .btn-secondary.dropdown-toggle {
  background: white !important;
}
</style>
